import { jsx as e } from "react/jsx-runtime";
import { FormField as t } from "../FormField.js";
import { BaseInput as o } from "../BaseStyledComponents/BaseInput.js";
import { limitInputLength as r } from "../../utils/limitInputLength.js";
const n = ({ control: n2, name: a, label: l, onFocus: u, onChange: i, type: s = "text", placeholder: d = "Введіть значення", required: m = false, preview: c = false, maxLength: p = 50, disabled: h, autoFocus: g, startDecorator: v, endDecorator: F, onInput: f, value: b, loading: j, hint: x }) => {
  const B = (e2) => {
    const t2 = e2.target.value || null;
    n2.setFieldValue(a, t2);
  }, D = (e2) => {
    const t2 = e2.target.value.trimStart();
    n2.setFieldValue(a, t2);
  };
  return e(t, { control: n2, name: a, label: l, required: m, preview: c, disabled: h, value: b, loading: j, hint: x, children: ({ name: t2, value: n3, onBlur: a2, fieldRef: l2 }) => e(o, { type: s, name: t2, value: n3 || "", onFocus: u, onChange: r(p, i || ("number" === s ? B : D)), onBlur: a2, placeholder: d, disabled: h, autoFocus: g, startDecorator: v, endDecorator: F, onInput: f, slotProps: { input: { ref: l2 } } }) });
};
export {
  n as InputField
};
//# sourceMappingURL=InputField.js.map
